import LocalizedStrings from 'react-localization';

import yolande from '../assets/images/slider/J004-664X830.jpg';
import podcast from "../assets/images/slider/Alison_Chantal_664X830.jpg";
import asl from "../assets/images/slider/comm-asl-664x830.jpg";
import ndtren from "../assets/images/slider/comm-reconciliation-664x830-en.jpg";
import ndtrfr from "../assets/images/slider/comm-reconciliation-664x830-gem.jpg";
import twisted from "../assets/images/slider/comm-twisted-histories-664x830.jpg"
import notok from "../assets/images/slider/notok-texte-complet-664x830.jpg";
import spotlighten from "../assets/images/slider/spotlight_autochtone_664x830_en.jpg";
import spotlightfr from "../assets/images/slider/spotlight_autochtone_664x830_fr.jpg";
import mandyen from "../assets/images/slider/spotlight_mandy_luk_664x830_en.jpg";
import mandyfr from "../assets/images/slider/spotlight_mandy_luk_664x830_fr.jpg";
import a11yen from "../assets/images/slider/a11y-en.jpg";
import a11yfr from "../assets/images/slider/a11y-fr.jpg";
import indigenous2022fr from "../assets/images/slider/mois-national-histoire-autochtone-2022.jpeg";
import indigenous2022en from "../assets/images/slider/national-indigenous-history-month-2022.jpeg";
import wigfr from "../assets/images/slider/certification-wig-fr.jpeg";
import wigen from "../assets/images/slider/certification-wig-en.jpeg";
import logorc from "../assets/images/slider/logo-rcca-bg-white.jpeg";
import commccmm from "../assets/images/slider/comm-ccmm.jpeg";




let strings = new LocalizedStrings({

    en: {
        title: "Reflecting contemporary Canada",
        content: "We will reflect the range and richness of this country’s diversity, celebrating our different perspectives, and all the things that bring us together. We will do this in our staffing, as well as our content choices.",
        slide1: {
            img: a11yen,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/blog/a-more-accessible-cbc-radio-canada",
            text: "Our Accessibility Lead, Rachel Desjourdy, addresses disability, accessibility, how the public broadcaster is aiming to do better and how you can take part in this important work.",
            alt: 'Accessibility'
        },
        slide2: {
            img: ndtren,
            link: "https://cbc.radio-canada.ca/en/media-centre/national-day-for-truth-and-reconciliation-day-programming",
            text: "CBC/Radio-Canada announces programming for first-ever National Day for Truth and Reconciliation.",
            alt: "National Day for truh and reconcialiation"
        },
        slide3: {
            img: twisted,
            link: "https://cbc.radio-canada.ca/en/media-centre/telling-our-twisted-histories-podcast",
            text: "New CBC podcast Telling Our Twisted Histories launches May 31 hosted by Kaniehti:io Horn",
            alt: "Telling Our Twisted Histories"
        },
        slide4: {
            img: podcast,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/podcast/black-female-journalists-expanding-the-narrative",
            text: "An inspiring conversation between producers Tamika Forester and Omayra Issa",
            alt: "Podcast"
        },
        slide5: {
            img: asl,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/blog/cbc-bc-asl-interpreted-town-hall",
            text: "CBC British Columbia breaks new ground with ASL-interpreted town hall",
            alt: "ASL-interpreted town hall"
        },
        slide6: {
            img: mandyen,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/blog/spotlight-mandy-luk",
            text: "Inclusive journalism as seen by Mandy Luk",
            alt: "Spotlight Mandy Luk"
        },
        slide7: {
            img: yolande,
            link: "https://cbc.radio-canada.ca/en/media-centre/yolande-james-appointed-executive-director-diversity-and-inclusion-radio-canada",
            text: "Yolande James appointed Executive Director, Diversity and Inclusion, Radio-Canada",
            alt: "Yolande James"
        },
        slide8: {
            img: spotlighten,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/blog/important-word-from-indigenous-colleagues",
            text: "An important word from our Indigenous colleagues",
            alt: "Spotlight Indigenous colleagues"
        },
        slide9: {
            img: notok,
            link: "https://cbc.radio-canada.ca/en/media-centre/attacks-targeting-media-professionals-are-notok",
            text: "Reminding the world that attacks targeting media professionals are #NotOk",
            alt: "Not Ok – stand up for journalism and democracy"
        },
        slide10: {
            img: indigenous2022en,
            link: "https://cbc.radio-canada.ca/en/media-centre/celebrating-national-indigenous-history-month-2022",
            text: "CBC/Radio-Canada celebrates National Indigenous History Month",
            alt: "National indigneous history month"
        },
        slide11: {
            img: logorc,
            link: "https://cbc.radio-canada.ca/en/media-centre/radio-canada-paid-internship-programs",
            text: "Radio-Canada launches paid internship program for racialized and Indigenous professionals",
            alt: "Radio-Canada logo"
        },
        slide12: {
            img: commccmm,
            link: "https://cbc.radio-canada.ca/en/media-centre/bringing-people-together-in-a-polarized-world-speech-catherine-tait",
            text: "Bringing People Together in a Polarized World",
            alt: "The chamber of Commerce of Metropolitan Montreal logo, cbc logo and catherine tait's portrait"
        },
        slide13: {
            img: wigen,
            link: "https://cbc.radio-canada.ca/en/your-public-broadcaster/blog/2021-gender-parity-award",
            text: "Gender parity: CBC/Radio-Canada recognized for a third straight year!",
            alt: "Women in governance party certified 2021 platinum"
        },
    },
        fr: {
            title: "Incarner le Canada d’aujourd’hui",
            content: "Nous continuerons de refléter la diversité de ce pays dans toute sa richesse, en mettant en valeur nos différentes perspectives et tout ce qui nous rassemble. Cette volonté se traduira tant dans nos effectifs que dans nos choix de contenus.",
            slide1: {
                img: a11yfr,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/blogue/rendre-cbc-radio-canada-plus-accessible",
                text: "Notre responsable de l’accessibilité, Rachel Desjourdy, parle de handicap et d’accessibilité et explique ce que compte faire le diffuseur public pour améliorer les choses ainsi que ce que vous pouvez faire dans le cadre de cette initiative importante.",
                alt: 'accessibilité'
            },
            slide2: {
                img: ndtrfr,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/programmation-pour-journee-nationale-de-la-verite-et-reconciliation",
                text: "CBC/Radio-Canada annonce sa programmation pour la toute première Journée nationale de la vérité et de la réconciliation",
                alt: "Journée nationale de la vérité et de la réconciliation"
            },
            slide3: {
                img: twisted,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/telling-our-twisted-histories-balado",
                text: "Le nouveau balado de CBC Telling Our Twisted Histories est lancé le 31 mai avec Kaniehti:IO Horn à l’animation",
                alt: "Telling Our Twisted Histories"
            },
            slide4: {
                img: podcast,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/balado/deux-journalistes-deux-generations-meme-passion",
                text: "Une conversation intergénérationnelle sur le journalisme, avec Alison Vicrobeck et Chantal Albert.",
                alt: "Podcast"
            },
            slide5: {
                img: asl,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/blogue/cbc-bc-asl-d-une-rencontre-virtuelle",
                text: "CBC British Columbia innove avec l’interprétation en langue ASL d’un événement virtuel",
                alt: "interprétation en langue ASL d’un événement virtuel"
            },
            slide6: {
                img: mandyfr,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/blogue/mandy-luk-projecteurs",
                text: "Le journalisme inclusif vu par Mandy Luk",
                alt: "Sous les projecteurs Mandy Luk"
            },
            slide7: {
                img: yolande,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/yolande-james-nommee-directrice-generale-diversite-et-inclusion-de-radio-canada",
                text: "Yolande James est nommée directrice générale, Diversité et inclusion de Radio-Canada",
                alt: "Yolande James"
            },
            slide8: {
                img: spotlightfr,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/blogue/un-mot-fois-parole-a-nos-collegues-autochtones",
                text: "Un mot à la fois : la parole à nos collègues autochtones",
                alt: "Sous les projecteurs: collègues autochtones"
            },
            slide9: {
                img: notok,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/attaques-visant-les-professionnels-des-medias-cestassez",
                text: "Les attaques visant les professionnels des médias : #CestAssez",
                alt: "C'est assez – défendons le journalisme et la démocracie"
            },
            slide10: {
                img: indigenous2022fr,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/celebrer-le-mois-national-de-histoire-autochtone-2022",
                text: "CBC/Radio-Canada célèbre le Mois national de l’histoire autochtone",
                alt: "Mois national de l’histoire autochtone"
            },
            slide11: {
                img: logorc,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/radio-canada-programme-de-stages-remuneres",
                text: "Radio-Canada lance un programme de stages rémunérés pour les professionnels racisés et autochtones",
                alt: "Logo de Radio-Canada"
            },
            slide12: {
                img: commccmm,
                link: "https://cbc.radio-canada.ca/fr/salle-de-presse/ambition-de-rassembler-dans-un-monde-polarise-discours-catherine-tait",
                text: "L’ambition de rassembler dans un monde polarisé",
                alt: "Logo de la chambre de commerce du Montréal métropolitain, logo de radio-canada et portrait de catherine tait"
            },
            slide13: {
                img: wigfr,
                link: "https://cbc.radio-canada.ca/fr/votre-diffuseur-public/blogue/2021-prix-parite-hommes-femmes",
                text: "Parité femmes-hommes : CBC/Radio-Canada reconnue pour une troisième année d'affilée!",
                alt: "La gouvernance au féminin , certifié parité, 2021 platine"
            },

        }
    })

export default strings;